export enum LOCAL_STORAGE {
    countries = 'countries',
    capitalCitiesHighScore = 'capitalCitiesHighScore'
  }
  